import * as styles from "./index.module.scss";

interface TagBadgeProps {
  name: string;
}

export function TagBadge({ name }: TagBadgeProps) {
  return <span className={styles.tagBadge}>{name}</span>;
}
